export const en = {
  __currency_code__: "USD",
  __currency__: "USD",
  __currency_symbol__: "$",
  __locale__: "en-US",

  "2d": "2D",
  "3d": "3D",
  viewMode2dPlan: "2D Plan",
  viewMode3dView: "3D View",
  viewModeToggleLabel: "View mode",
  fitCameraTip: "Fit to scene",
  zoomIn: "Zoom in",
  zoomOut: "Zoom out",
  grid: "Grid",
  rapidPlanner: "RapidPlanner",
  save: "Save",
  saveDisabledTip: "Saving will be available soon",
  myRenders: "My Renders",
  myRendersHint: "Your recently captured render images",
  myRendersEmpty: "No saved renders yet. Capture a view from 3D mode.",
  myRendersCapture: "Add current view",
  myRendersCapturing: "Adding…",
  rendersTabMy: "My Renders",
  rendersTabRapid: "RapidRender",
  rapidRendersEmpty: "No RapidRender images yet.",
  rapidRendersLoading: "Loading renders…",
  rapidRendersPending: "Rendering…",
  rapidRendersError: "Render failed.",
  rapidRendersLoadMore: "Load more",
  renderCapture: "AI Render",
  renderCapturing: "Rendering…",
  aiRenderTitle: "AI Render",
  aiRenderHint: "Describe the look you want, then start the render.",
  aiRenderPrompt: "Prompt",
  aiRenderPromptPlaceholder:
    "e.g. soft daylight, warm wood tones, cozy living room…",
  aiRenderResolution: "Resolution",
  aiRenderPersonalize: "Personalize",
  aiRenderAddPlant: "Add plant",
  aiRenderAddArtwork: "Add artwork",
  aiRenderAddDecor: "Add decor",
  aiRenderStart: "Start render",
  aiRenderProgressTitle: "Preparing render",
  aiRenderProgressWorking: "Working…",
  aiRenderProgressBeauty: "Capturing view",
  aiRenderProgressAlbedo: "Capturing albedo",
  aiRenderProgressTopView: "Capturing top view",
  aiRenderProgressNormal: "Capturing normals",
  aiRenderProgressDepth: "Capturing depth",
  aiRenderProgressSend: "Sending to RapidRender",
  sceneAiTitle: "Rapid AI",
  sceneAiSettings: "API settings",
  sceneAiProvider: "Provider",
  sceneAiModel: "Model",
  sceneAiSearchModel: "Search models…",
  sceneAiNoModels: "No matching model. You can still use this name.",
  sceneAiApiKey: "API key",
  sceneAiEmpty: "Describe the apartment or room. The AI will place the floor plan, rooms, and furniture.",
  sceneAiPlaceholder: "e.g. 110 m², 2-bed, open kitchen, entry from the south…",
  sceneAiAttachImage: "Attach photo",
  sceneAiRemoveImage: "Remove photo",
  sceneAiDropImage: "Drop a photo here",
  sceneAiSend: "Send",
  sceneAiSending: "Sending…",
  sceneAiNeedKey: "Enter an API key in settings first.",
  sceneAiThinking: "Thinking",
  sceneAiTool: "Tool",
  sceneAiYes: "Yes, apply",
  sceneAiNo: "No",
  sceneAiBrief: "Brief",
  sceneAiBriefHard: "required",
  sceneAiBriefSoft: "preferences",
  sceneAiBriefAssume: "assumptions",
  sceneAiBriefUnknown: "questions",
  sceneAiBriefOpen: "open",
  sceneAiBriefOk: "Met",
  sceneAiBriefFail: "Not met",
  sceneAiBriefUnchecked: "Not scored",
  authLoginTitle: "Sign in",
  authLoginSubtitle: "Sign in to continue this action.",
  authEmail: "Email",
  authPassword: "Password",
  authSignIn: "Sign in",
  authSigningIn: "Signing in…",
  authCancel: "Cancel",
  authSelectCompany: "Choose a company",
  authErrorInvalid: "Invalid email or password.",
  authErrorRecaptcha: "Please confirm you are not a robot.",
  authErrorGeneric: "Could not sign in. Try again.",
  authLogout: "Sign out",
  authAccount: "Account",
  pathTraceRender: "Render",
  download: "Download",
  share: "Share",
  close: "Close",
  //SugarModelViewer / material panel
  viewerCustomize: "Customize",
  viewerPartFabricSelection: "Part & fabric selection",
  viewerPanelNote:
    "Final color may vary by production batch. Use the Get Quote button to request a sample.",
  viewerClose: "Close",
  viewerAR: "AR",
  viewerQrTitle: "View in Your Home",
  viewerQrInformText:
    "*To use this feature, you need a smartphone that supports augmented reality.*",
  viewer3dDownload: "Download 3D",
  viewerGetQuote: "Get Quote",
  viewerToolbar: {
    materials: "Materials",
    dimensions: "Dimensions",
    help: "Help",
    gallery: "Gallery",
    share: "Share",
    fullscreen: "Fullscreen",
    exitFullscreen: "Exit fullscreen",
    pathTrace: "Path Trace",
    pathTraceSettings: "Path Trace settings",
  },
  download3d: {
    defaultModel: "Model",
    dialogLabel: "3D model download request",
    badge: "3D Model Download",
    title: "Send us a request to use the models.",
    subtitle: "For use in platforms like 3ds Max, SketchUp, and Revit.",
    configuration: "Configuration",
    notice:
      "When your model download request is approved, you will be notified by email.",
    supportedFormats: "Supported formats: FBX · GLB · BLEND",
    exportFormats: "File formats",
    formatRequired: "Select at least one file format.",
    format: {
      fbx: "FBX (3ds Max, Maya)",
      glb: "GLB (glTF)",
      blend: "Blender (BLEND)",
    },
    firstName: "First name",
    lastName: "Last name",
    email: "Email",
    phone: "Phone",
    phoneCountryCode: "Phone country code",
    projectCountry: "Project Country",
    projectCity: "Project City",
    selectCountry: "Select country",
    selectCountryFirst: "Select country first",
    cityPlaceholder: "Enter city",
    company: "Company / Studio",
    note: "Note",
    submit: "Send Request",
    verifyAndSubmit: "Verify and Submit Download Request",
    otpCode: "Verification code",
    otpTitle: "Enter verification code",
    otpPlaceholder: "000000",
    otpHint: "Enter the 6-digit code sent to your phone.",
    otpResend: "Send new code",
    otpBack: "Edit details",
    otpResendHint: 'Tap "Send new code" to receive a fresh verification code.',
    otpRequired: "Please enter the verification code.",
    validationError: "Please fill in all required fields.",
    unexpectedResponse: "Unexpected server response.",
    rateLimit: "Too many attempts. Please try again later.",
    genericError: "Download request could not be sent. Please try again.",
    successTitle: "Your download request was received",
    successSubtitle:
      "You will be notified by email when your request is approved.",
    successDismissHint: "This window will close in a few seconds.",
  },
  quoteRequest: {
    dialogLabel: "Quote request",
    badge: "Advantageous Prices",
    title:
      "Send your request and we will get back to you within 1 business day.",
    subtitle:
      "We quickly share a special advantageous quote for your configuration.",
    quantity: "Quantity",
    decreaseQuantity: "Decrease quantity",
    increaseQuantity: "Increase quantity",
    details: "Request details",
    detailsPlaceholder: "Fabric, color, delivery time, special notes...",
    submit: "Send Quote Request",
    contactMethod: "Verification channel",
    contactPhone: "Phone (SMS)",
    contactEmail: "Email",
    verifyAndSubmit: "Verify and Send Quote Request",
    otpCode: "Verification code",
    otpTitle: "Enter verification code",
    otpPlaceholder: "000000",
    otpHint: "Enter the 6-digit code sent to your selected channel.",
    otpResend: "Send new code",
    otpBack: "Edit details",
    otpResendHint: 'Tap "Send new code" to receive a fresh verification code.',
    otpRequired: "Please enter the verification code.",
    validationError: "Please fill in all required fields.",
    unexpectedResponse: "Unexpected server response.",
    rateLimit: "Too many attempts. Please try again later.",
    genericError: "Could not send quote request. Please try again.",
    successTitle: "Your quote request was received",
    successSubtitle: "Your quote number:",
    successDismissHint: "This window will close in a few seconds.",
  },
  roomQuote: {
    tip: "Get Quote",
    sceneSummary: "Scene products",
    productsLabel: "Products in scene",
    emptyScene: "Add at least one product to the scene before requesting a quote.",
    categoryCountBlockedTitle: "Quantity is not valid for a quote",
    categoryCountBlocked:
      "The number of {{category}} products in the scene must be a multiple of {{multiple}} before you can request a quote.",
    missingCompany: "Company information is missing. Please check the catalog.",
    fullName: "Full name",
    phone: "Phone",
    headline: "Print your design or request a quote with advantageous prices.",
    submit: "Get Quote",
    contactRequired: "Please enter your full name and phone number.",
    draftSaved: "Your details were saved. Opening the quote form…",
    sku: "SKU",
  },
  viewerApiErrors: {
    RATE_LIMIT: "Too many attempts. Please try again later.",
    ORIGIN_DENIED: "This action is not allowed from your site.",
    CHANNEL_NOT_FOUND:
      "This service is not configured for the selected company.",
    VALIDATION_ERROR: "Please check the information you entered.",
    OTP_FAILED: "Verification code is invalid or has expired.",
    ACCESS_DENIED: "You are not allowed to perform this action.",
    MISSING_PUBLIC_KEY: "Quote integration is not configured.",
    CRM_VALIDATION:
      "The request could not be processed. Please check your details.",
    NOT_FOUND: "The requested resource was not found.",
    SERVICE_ERROR: "Service is temporarily unavailable. Please try again.",
    GENERIC_ERROR: "The operation could not be completed. Please try again.",
  },
  ar: {
    exit: "Exit AR",
    hint: "Find a surface, drag and rotate the product",
    startedSearching: "AR started — searching for a surface",
    preparingModel: "Preparing the 3D model…",
    openInAr: "Open in AR",
    surfaceFound: "Surface found",
    productPlaced: "Product placed",
    rotating: "Rotating…",
    light: "Light",
    depth: "Depth",
    checking: "Checking",
    capabilityChecking: "Checking {{label}} support",
    capabilityOnTapToOff: "{{label}} is on, tap to turn off",
    capabilityOffTapToOn: "{{label}} is off, tap to turn on",
    capabilityUnsupported: "{{label}} is not supported on this device/browser",
    lightEstimationActive: "Light estimation active",
    lightEstimationOn: "Light estimation on",
    lightEstimationOff: "Light estimation off",
    depthOcclusionActive: "Depth occlusion active",
    depthOcclusionOn: "Depth occlusion on",
    depthOcclusionOff: "Depth occlusion off",
  },
  confirm: "Confirm",
  confirmshape: "Update Shape",
  notFound: "Not Found",
  next: "Next",
  back: "Back",
  export: " Export",
  gapWidth: "Gap Width",
  wallWidth: "Wall Width",
  balconyWidth: "Balcony Width",
  clearAllTip: "Clear All",
  drawBalconyTip: "Draw Balcony",
  drawWallTip: "Draw Wall",
  selectToolTip: "Select",
  drawGapTip: "Draw Gap",
  downloadPdfTip: "Download as PDF",
  search: "Search",
  //WelcomeMenu.tsx
  welcomeMenuWelcome: "Hello! Welcome to the Planner!",
  drawRoomShape: "Draw Own Room",
  chooseRoomShapeFromTemplates: "Choose From Templates",
  chooseRoomShape: "Choose Room Shape",
  //MainPane.tsx
  roomFeatures: "Resize",
  roomStyle: "Room Style",
  door: {
    opensIn: "Opens inward",
    opensOut: "Opens outward",
    hingeStart: "Hinge (start)",
    hingeEnd: "Hinge (end)",
    openAngle: "Opening angle",
  },
  structural: {
    menu: "Structure",
    rectColumn: "Rectangular column",
    roundColumn: "Round column",
    beam: "Beam",
    radiator: "Radiator",
    pool: "Pool",
    width: "Width",
    depth: "Depth",
    height: "Height",
    diameter: "Diameter",
    widthCm: "Width (cm)",
    depthCm: "Depth (cm)",
    heightCm: "Height (cm)",
    diameterCm: "Diameter (cm)",
    columnHeightLocked: "Height locked to room height",
    elevation: "Elevation",
    elevationCm: "Elevation (cm)",
    beamElevationHint: "Bottom height from floor. Initial place is at the ceiling.",
    elevationHint: "Height from floor. In 3D, use Horizontal/Vertical to choose the drag axis.",
    moveMode: "Move",
    moveHorizontal: "Horizontal",
    moveVertical: "Vertical",
    moveGizmo: "Move with axes",
  },
  lighting: "Lighting",
  settings: "Settings",
  lengthUnit: "Length unit",
  lengthUnitCm: "Centimeter (cm)",
  lengthUnitMm: "Millimeter (mm)",
  lengthUnitInch: "Inch (in)",
  hdrSelection: "HDR selection",
  hdrPreview: "HDR preview",
  renderSettings: "Rendering",
  toneMapping: "Tone mapping",
  disabled: "Off",
  exposure: "Exposure",
  environmentLight: "Environment light",
  aoMapIntensity: "AO map intensity",
  ambientOcclusion: "Ambient occlusion",
  ssgi: "SSGI",
  ssgiHint:
    "Screen-space GI + AO. Disables GTAO while on.",
  ssgiSparse: "SSGI Sparse",
  ssgiSparseHint:
    "Grid-stride GI only (no AO). Off-grid pixels interpolate four neighbors.",
  ssgiOutput: "Output",
  ssgiOutputCombined: "Combined",
  ssgiOutputDirect: "Direct",
  ssgiOutputAo: "AO",
  ssgiOutputGi: "GI",
  ssgiOutputNormal: "Normal (MRT)",
  ssgiOutputDepth: "Depth",
  ssgiOutputGiDebug: "GI Debug",
  ssgiOutputGiSource: "GI source",
  gtaoHint: "Available when SSGI and Path Trace are off.",
  gtaoSamples: "Samples",
  gtaoScale: "Scale",
  gtaoDenoise: "Denoise",
  gtaoLumaPhi: "Luma Φ",
  gtaoDepthPhi: "Depth Φ",
  gtaoNormalPhi: "Normal Φ",
  gtaoPdRadius: "Denoise radius",
  distanceExponent: "Distance exponent",
  distanceFallOff: "Distance falloff",
  resolutionScale: "Resolution scale",
  pixelRatioScale: "Resolution factor",
  pixelRatioScaleHint:
    "Multiplied by the browser devicePixelRatio. 1 = native device resolution. Lower values soften the image and raise FPS.",
  imageQuality: "Image quality",
  qualitySmooth: "Smooth",
  qualityBalanced: "Balanced",
  qualitySharp: "Sharp",
  clarityHint: "Lower sharpness runs more smoothly.",
  editLights: "Edit lights",
  advancedDisplay: "Advanced display",
  settingsSectionEnvironment: "Environment",
  environmentFallback: "Environment",
  pathTraceHint:
    "Progressive path tracing (WebGL2 sidecar). Disables SSGI / GTAO / TAA while on.",
  pathTraceFrameCount: "Path Trace frames",
  pathTraceRenderScale: "Render scale",
  pathTraceBounces: "Bounces",
  pathTraceSamplesPerFrame: "Samples / frame",
  pathTraceFilterGlossy: "Filter glossy",
  pathTraceFadeDuration: "Fade (ms)",
  sliceCount: "Slice count",
  stepCount: "Step count",
  giIntensity: "GI intensity",
  aoIntensity: "AO intensity",
  thickness: "Thickness",
  expFactor: "Exp factor",
  backfaceLighting: "Backface lighting",
  useLinearThickness: "Use linear thickness",
  useScreenSpaceSampling: "Screen-space sampling",
  useTemporalFiltering: "Temporal filtering",
  giStride: "GI stride",
  giAdaptive: "GI adaptive",
  giAdaptiveOff: "Off",
  giAdaptiveEdge: "Edge",
  giAdaptiveRefine: "Refine",
  giAdaptiveRefineHint:
    "Full GI on coarse cells whose 9 depth/normal taps disagree. Uses the depth and normal gates below.",
  giEdgeThickness: "GI edge thickness",
  giEdgeKernel: "GI edge kernel",
  giEdgeKernelCross: "Cross (4-tap)",
  giEdgeKernelSobel: "Sobel",
  giEdgeKernelPrewitt: "Prewitt",
  giEdgeKernelScharr: "Scharr",
  giEdgeThreshold: "GI edge threshold",
  giDepthThreshold: "GI depth gate",
  giNormalThreshold: "GI normal gate",
  giMinOkCount: "Min valid taps",
  ssgiSparseVersion: "Version",
  ssgiSparseVersionV1: "v1 (old)",
  ssgiSparseVersionV2: "v2 (history)",
  ssgiSparseV2Hint:
    "GI + AO. One pixel per cell is traced, a different one each frame; only GI accumulates, newly revealed areas are smoothed.",
  giHistoryLength: "History length (frames)",
  giDenoisePasses: "Denoise passes",
  giEdgeRefine: "Extra tracing on edges",
  intensity: "Intensity",
  radius: "Radius",
  raySamples: "Ray samples",
  accumulation: "Accumulation",
  denoise: "Denoise",
  sampleLevel: "Sample level",
  unbiased: "Unbiased sampling",
  settingsSectionDisplay: "Display",
  settingsSectionLighting: "Lighting",
  settingsSectionColor: "Color",
  antialias: "Anti-alias",
  antialiasSamples: "AA samples",
  fxaa: "FXAA",
  msaa: "MSAA",
  msaaSamples: "MSAA samples",
  shadows: "Shadows",
  shadowQuality: "Shadow quality",
  qualityLow: "Low",
  qualityMedium: "Medium",
  qualityHigh: "High",
  resetRenderSettings: "Reset rendering settings",
  fullReset: "Full reset",
  help: "Help",
  volumeDebug: "Volumes",
  cornerLineSnap: "Corner align",
  volumeDebugCollision: "Collision (while dragging)",
  volumeDebugObb: "OBB",
  volumeDebugAabb: "Bounding box",
  volumeDebugHint:
    "OBB uses two colors: parts and hull. Collision uses the contact color. The world box stays axis-aligned.",
  volumeDebugColorParts: "Part color",
  volumeDebugColorHull: "Hull color",
  volumeDebugColorContact: "Contact color",
  volumeDebugColorAabb: "World box color",
  appMode: "Mode",
  liveMode: "Live",
  devMode: "Dev",
  usageTips: "Usage tips",
  restartTour: "Restart tour",
  start: "Start",
  roomLights: "Room lights",
  roomLightsLoading: "Preparing room lights…",
  height: "Height",
  spacing: "Spacing",
  distance: "Distance",
  decay: "Decay",
  color: "Color",
  roomLightShadows: "Room-light shadows",
  automatic: "Automatic",
  reset: "Reset",
  lightCount: "lights",
  wallColor: "Wall color",
  floorColor: "Floor color",
  ceilingColor: "Ceiling color",
  windowColor: "Window color",
  doorColor: "Door color",
  surfaceWall: "Wall",
  surfaceFloor: "Floor",
  surfaceCeiling: "Ceiling",
  surfaceWindow: "Window",
  surfaceDoor: "Door",
  chooseFromColorPalette: "Choose from color palette",
  chooseFromColorPaletteHint: "Pick a custom color from the spectrum",
  floorMaterials: "Flooring",
  floorMatParquet01: "Parquet 01",
  floorMatParquet02: "Parquet 02",
  floorMatParquet03: "Parquet 03",
  floorMatParquet04: "Parquet 04",
  floorMatParquet05: "Parquet 05",
  floorMatParquet06: "Parquet 06",
  floorMatParquet07: "Parquet 07",
  floorMatParquet08: "Parquet 08",
  floorMatParquet09: "Parquet 09",
  floorMatParquet10: "Parquet 10",
  floorMatParquet11: "Parquet 11",
  floorMatParquet12: "Parquet 12",
  floorMatParquet13: "Parquet 13",
  floorMatParquet14: "Parquet 14",
  floorMatParquet15: "Parquet 15",
  floorMatParquet16: "Parquet 16",
  floorMatParquet17: "Parquet 17",
  floorMatParquet18: "Parquet 18",
  floorMatParquet19: "Parquet 19",
  floorMatParquet20: "Parquet 20",
  floorMatParquet21: "Parquet 21",
  floorMatParquet22: "Parquet 22",
  floorMatOakParquet: "Oak parquet",
  floorMatWalnutParquet: "Walnut parquet",
  floorMatAshParquet: "Ash parquet",
  floorMatHoneyOak: "Honey oak",
  floorMatDarkOak: "Dark oak",
  floorMatCherryParquet: "Cherry parquet",
  floorMatTeakParquet: "Teak parquet",
  floorMatSmokedOak: "Smoked oak",
  floorMatOakHerringbone: "Oak herringbone",
  floorMatWalnutHerringbone: "Walnut herringbone",
  floorMatOakWidePlank: "Oak wide plank",
  floorMatWalnutWidePlank: "Walnut wide plank",
  floorMatAshWashedPlank: "Ash washed plank",
  floorMatOakChevron: "Oak chevron",
  floorMatBleachedOak: "Bleached oak",
  floorMatSilverWashedOak: "Silver washed oak",
  floorMatWarmOak: "Warm oak",
  floorMatBeigeGeoPanel: "Beige geometric panel",
  floorMatCharcoalGeoPanel: "Charcoal geometric panel",
  floorMatTravertineBeige: "Beige travertine",
  floorMatWhiteMarble: "White marble",
  floorMatCarraraMarble: "Carrara marble",
  floorMatGrayMarble: "Gray marble",
  floorMatBlackMarble: "Black marble",
  floorMatCalacattaMarble: "Calacatta marble",
  floorMatVerdeMarble: "Verde marble",
  floorMatTravertineMarble: "Travertine",
  floorMatRossoMarble: "Rosso marble",
  floorMatLightTile: "Light ceramic tile",
  floorMatGrayTile: "Gray ceramic tile",
  floorMatTerracottaTile: "Terracotta tile",
  floorMatConcrete: "Concrete",
  floorMatGrass: "Grass",
  newSceneTip: "New scene",
  newSceneConfirmTitle: "Create a new scene?",
  newSceneConfirmBody: "The current scene will be cleared.",
  newSceneConfirm: "Clear scene",
  selectFabricFromList: "Select Fabric from List",
  sku: "SKU",
  cancelAction: "Cancel",
  deleteSelectionTip: "Delete selected",
  drawWall: "Shapes",
  showReport: "Offer",
  addToRoom: "Products",
  authorizedCatalogUnauthorized: "Sign in required.",
  authorizedCatalogEmpty: "No results.",
  authorizedCatalogLoadMore: "Load more",
  authorizedFacetCatalogs: "Catalogs",
  authorizedFacetCategories: "Categories",
  authorizedFacetTypeCategories: "Type categories",
  authorizedFacetCollections: "Collections",
  authorizedClearFacets: "Clear",
  authorizedFilters: "Filters",
  authorizedChooseFilterHint:
    "Use the filter icon to pick a catalog or category.",
  authorizedProductsTitle: "Products",
  authorizedHideProducts: "Hide products",
  cameraView: "View",
  cameraViewTop: "Top",
  cameraViewLeft: "Left",
  cameraViewRight: "Right",
  cameraViewTopHint: "Look from above",
  cameraViewLeftHint: "Look from the side",
  cameraViewRightHint: "Look from the front",
  configure: "Configure",
  //RoomShaping.tsx
  changeRoomShape: "Change Room Shape",
  roomShapeStartMessage:
    "Let's design your living space together! Before entering measurements, pick the shape that best matches your area.",
  selectRoomTemplate: "Select Template",
  drawFromScratch: "Draw from Scratch",
  newRoom: "Clear",
  roomShapeOnlyFloor: "Open floor",
  roomShapeFloorWithSingleWall: "Single Wall",
  roomShapeCorner: "Corner",
  roomDoubleBalcony: "Corner Shape",
  roomShapeRectangle: "Rectangle",
  roomShapeSquare: "Square",
  roomShapeLShape: "L Shape",
  roomShapeZShape: "Z Shape",
  roomShapeUShape: "U Shape",
  roomShapeTShape: "T Shape",
  roomShape5Sides: "5 Side",
  roomShapeBevelShape: "Bevel Shape",
  //RoomModifying.tsx
  wallResize: "Resize Walls",
  glassPriceMultiplier: "Glass Price per Meter",
  basePriceMultiplier: "Base Price per Unit",
  buyerName: "Buyer Name",
  dimensions: "Dimensions",
  resetArea: "Reset Area",
  undo: "Undo",
  redo: "Redo",
  topView: "Top View",
  createRender: "Create Render",
  calculating: "Calculating...",
  loading: "Loading...",
  productList: "Product List",
  pdfReport: {
    defaultProjectName: "design-summary",
    designReport: "Design Report",
    designSummary: "Your Design Summary",
    downloadPdf: "PDF",
    print: "Print",
    share: "Share",
    requestQuote: "Get Quote",
    close: "Close",
    downloaded: "PDF downloaded.",
    contentNotFound: "Report content was not found",
    screenshotUnavailable: "Screenshot could not be captured",
    addImage: "Add image",
    capturingViews: "Preparing views…",
    removeImage: "Remove image",
    pickImage: "Choose an image",
    products: "Products",
    image: "Image",
    code: "Code",
    sizeCm: "Size (cm)",
    noProducts: "No products found",
    shareUnavailable: "No image available to share.",
    buyerInfo: "BUYER INFORMATION",
    phoneLabel: "PHONE",
    address: "ADDRESS",
    billingAddress: "BILLING ADDRESS",
    billingSameAsCustomer: "Billing address is the same as the customer address.",
    sectionOne: "Section 1",
    colIndex: "#",
    colProduct: "Product",
    colQty: "Qty",
    colUnit: "Unit",
    unitPiece: "Pcs",
    colCustomized: "Customized",
    colDiscount: "Discount",
    colGrandTotal: "Grand Total",
    currency: "Currency",
    emptyValue: "—",
  },
  proforma: {
    modelSummary: "Normod Design Summary",
    pdfGenerating: "Generating PDF...",
    pdfLibraryError: "PDF library could not be loaded",
    pdfError: "PDF could not be created. Please try again.",
    pdfError2: "An error occurred while creating the PDF. Please try again.",
    offerNo: "Offer No",
    quantity: "Quantity",
    product: "Product",
    price: "Price",
    subtotal: "Subtotal",
    dimensions: "Dimensions",
    materialType: "Material Type",
    materialColor: "Material Color",
    orderDate: "Order Date",
    discount: "Discount",
    taxIncluded: "Tax (Included) VAT-10%",
    total: "TOTAL",
    footer1: "Prices include VAT.",
    footer2: "Prices are valid for the day the form is created.",
    footer3:
      "This form is for offer purposes only and cannot be used for ordering.",
    footer4:
      "This design was prepared specifically for the person on {{date}}.",
    footer5:
      "Our products are designed for comfort. Since rich fiber and high elasticity premium sponges are used, stitches may not be straight and sharp.",
    footer6: "Colors on the screen may show tone differences.",
    footer7: "The validity period of the offer is 3 days.",
    preview3d: "3D Preview",
    setProjectName: "Set Project Name",
    pdfWillBeSavedAs: "The PDF file will be saved with this name",
    projectName: "Project Name",
    projectNamePlaceholder: "e.g. Kitchen Design",
    cancel: "Cancel",
    createPdf: "Create PDF",
    priceAsc: "Price ↑",
    priceDesc: "Price ↓",
    sort: "Sort",
    productDetails: "Product Details",
    cm: "cm",
    addToCart: "Add to Cart",
    share: "Share",
  },
  tips: {
    doneBtnText: "Got it",
    dontShowAgain: "Don't show again",
    onboarding: {
      welcomeTitle: "Welcome to Room Designer!",
      welcomeDesc:
        "Let's design your living space together! Before entering measurements, pick the shape that best matches your area, or start drawing from scratch.",
      canvasTitle: "Your Design Area",
      canvasDesc:
        "You'll view and edit your room here. Draw walls in 2D mode, place products and preview in 3D mode.",
      toolbarTitle: "Toolbar",
      toolbarDesc:
        "Drawing tools, window/door placement and panels are on the left. Let's go through them one by one.",
      viewModeTitle: "View Mode",
      viewModeDesc:
        "<b>2D</b>: Wall drawing and plan view.<br><b>3D</b>: Realistic preview and product placement. You can switch between them.",
      undoTitle: "Undo / Redo",
      undoDesc: "You can undo or redo your actions.",
      drawWallTitle: "Draw Wall",
      drawWallDesc:
        "After selecting this tool, click on the design area to set wall corners. Click the starting point to close the room.",
      windowTitle: "Add Window",
      windowDesc:
        "Select this tool, then click a wall to place a window. The door tool is right below it.",
      panelTitle: "Add Products",
      panelDesc:
        "Use this left-toolbar button to open the right panel and add furniture or accessories. The panel is open now — click or drag items to add them.",
      templatesTitle: "Templates",
      templatesDesc:
        "You can open ready-made templates from here anytime.",
      resizeTitle: "Resize",
      resizeDesc:
        "You can resize your room and change wall thickness here. Press Next to continue.",
      fullscreenTitle: "Fullscreen",
      fullscreenDesc:
        "Switch to fullscreen for a wider workspace. We'll open and close it.",
      doorTitle: "Add Door",
      doorDesc:
        "Select this tool, then click a wall to place a door.",
      zoomTitle: "Zoom Out / Zoom In",
      zoomDesc:
        "Scale the scene with zoom out and zoom in.",
      quoteTitle: "Get a Quote",
      quoteDesc:
        "When your design is ready, request a quote here. The quote window is open — press Next to close it.",
      categoriesTitle: "Room Style",
      categoriesDesc:
        "Change wall, floor and ceiling colors and floor materials from here.",
      helpTitle: "Need Help?",
      helpDesc:
        "Click this button to restart this tour anytime. Happy designing!",
    },
    contextual: {
      threeDModeTitle: "You're in 3D View",
      threeDModeDesc:
        "Right-click and drag to rotate the camera. Use the mouse wheel to zoom in and out.",
      drawerActiveTitle: "Drawing Mode Active",
      drawerActiveDesc:
        "Click on the design area to set corner points. Click the starting point again or double-click to finish drawing.",
      productSelectedTitle: "Product Selected",
      productSelectedDesc:
        "From this menu you can rotate, delete or replace the product with another one.",
      wallSelectedTitle: "Wall Settings",
      wallSelectedDesc:
        "From this window you can change the wall type and adjust dimensions.",
      cornerButtonsTitle: "Wall Extension Point",
      cornerButtonsDesc:
        "Click these '+' buttons to add new walls to existing corners.",
      backTo2dTitle: "You're in 2D Mode",
      backTo2dDesc:
        "Now you can draw walls, change wall dimensions and continue working in plan view.",
    },
    progress: {
      roomCreatedTitle: "Your Room is Ready!",
      roomCreatedDesc:
        "Use the products button in the left toolbar to add furniture and accessories. Drag-and-drop or click to add.",
      firstProductTitle: "First Product Added!",
      firstProductDesc:
        "Click a product to select it, then rotate, delete or replace it. Switch to 3D view to check how it looks.",
      threeDPreviewTitle: "3D Preview Looks Great!",
      threeDPreviewDesc:
        "Change wall, floor and ceiling colors from the Room Style button.",
      materialChangedTitle: "Your Design is Taking Shape!",
      materialChangedDesc:
        "When you're ready, request a quote or share your design as a PDF.",
      wallResizedTitle: "Wall Size Updated",
      wallResizedDesc: "Switch to 3D view to check how the changes look.",
    },
  },
  side: {
    backCushion: "Back Cushion",
    armOption: "Arm Option",
    fabricDetails: "Fabric Details",
    apply: "Apply",
    materialGroupDescription:
      "Select from the found fabric types and choose your desired color from its subgroup to customize your product.",
  },
};
